import { useEffect, useState } from "react";
import { X, Loader2 } from "lucide-react";
import api from "../lib/api";

const FILTERS = ["all", "goldly", "tokwin"];

export default function AdminWalletModal({ userId, onClose }) {
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    api.get(`/admin/users/${userId}/wallet`).then(r => setData(r.data)).catch(e => setErr(e?.response?.data?.detail || "Failed to load wallet"));
  }, [userId]);

  const rows = (data?.activity || []).filter(a => filter === "all" || a.currency === filter);

  return (
    <div className="fixed inset-0 z-[80] bg-black/75 backdrop-blur flex items-center justify-center p-4" onClick={onClose} data-testid="admin-wallet-modal">
      <div onClick={e => e.stopPropagation()} className="w-full max-w-2xl max-h-[88vh] flex flex-col rounded-3xl bg-[#0B0F19] border border-white/15 overflow-hidden">
        <div className="flex items-center gap-3 px-4 py-3 border-b border-white/10">
          {data && <img src={data.user.avatar} alt="" className="w-9 h-9 rounded-full"/>}
          <div className="flex-1 min-w-0">
            <div className="font-outfit font-bold truncate">{data ? `${data.user.name || data.user.username} · Wallet` : "Wallet"}</div>
            {data && <div className="text-[11px] text-white/55 truncate">@{data.user.username} · {data.user.email}</div>}
          </div>
          <button onClick={onClose} data-testid="admin-wallet-close" className="p-2 rounded-full bg-white/5"><X className="w-4 h-4"/></button>
        </div>
        {err && <p className="p-4 text-sm text-[#FF2A5F]">{err}</p>}
        {!data && !err && <div className="p-8 flex justify-center"><Loader2 className="w-6 h-6 animate-spin"/></div>}
        {data && (
          <div className="flex-1 overflow-y-auto p-4 space-y-4">
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-2" data-testid="admin-wallet-balances">
              {Object.entries(data.balances).map(([k, v]) => (
                <div key={k} className="p-3 rounded-2xl bg-white/5 border border-white/10" data-testid={`admin-wallet-${k}`}>
                  <div className="text-[10px] uppercase text-white/50">{k.replace("wallet_", "")}</div>
                  <div className="font-outfit font-extrabold text-xl">{Number(v).toLocaleString()}</div>
                </div>
              ))}
              {Object.entries(data.stats).map(([k, v]) => (
                <div key={k} className="p-3 rounded-2xl bg-white/[0.03] border border-white/5">
                  <div className="text-[10px] uppercase text-white/50">{k.replace(/_/g, " ")}</div>
                  <div className="font-bold">{Number(v || 0).toLocaleString()}</div>
                </div>
              ))}
            </div>
            <div className="flex gap-2">
              {FILTERS.map(f => (
                <button key={f} onClick={() => setFilter(f)} data-testid={`admin-wallet-filter-${f}`}
                  className={`px-3 py-1 rounded-full text-xs font-bold capitalize ${filter === f ? "bg-[#00E5FF] text-black" : "bg-white/10"}`}>{f}</button>
              ))}
              <span className="ml-auto text-xs text-white/50 self-center">{rows.length} entries</span>
            </div>
            <div className="space-y-1.5" data-testid="admin-wallet-activity">
              {rows.length === 0 && <p className="text-sm text-white/50 text-center py-6">No wallet activity yet.</p>}
              {rows.map((a, i) => (
                <div key={i} className="flex items-center gap-3 p-2.5 rounded-xl bg-white/5 text-xs">
                  <div className="flex-1 min-w-0">
                    <div className="truncate">{a.label}{a.price_inr ? ` · ₹${a.price_inr}` : ""}{a.status && a.status !== "completed" ? ` · ${a.status}` : ""}</div>
                    <div className="text-[10px] text-white/45">{new Date(a.created_at).toLocaleString()}</div>
                  </div>
                  <div className={`font-bold whitespace-nowrap ${a.amount >= 0 ? "text-emerald-400" : "text-[#FF2A5F]"}`}>
                    {a.amount >= 0 ? "+" : ""}{Number(a.amount).toLocaleString()} {a.currency === "tokwin" ? "T" : "G"}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
